import { render, staticRenderFns } from "./AutomaticSettings.vue?vue&type=template&id=41bef8f2&scoped=true&lang=html&"
import script from "./AutomaticSettings.vue?vue&type=script&lang=js&"
export * from "./AutomaticSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bef8f2",
  null
  
)

export default component.exports